/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_DescriptionInputs */

const en_settings_billing_description = /** @type {(inputs: Settings_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your subscriptions`)
};

/**
* | output |
* | --- |
* | "Manage your subscriptions" |
*
* @param {Settings_Billing_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_description = /** @type {((inputs?: Settings_Billing_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_description(inputs)
});
export { settings_billing_description as "settings.billing.description" }